/* eslint camelcase: ["off"] */
import React, { Component } from 'react';
import classNames from 'classnames';
import { format } from 'date-fns';
import { map, startCase } from 'lodash';
import { getNextWeekdayDate } from '../../../helpers/dates';
import ModalControls from '../modal/ModalControls';
import ModalFooter from '../modal/ModalFooter';
import ModalHeader from '../modal/ModalHeader';
import type { WeekdayLabels } from '../../../helpers/dates';

type Props = {
  log: any,
  onSubmit: (projectId: any, payload: any) => Promise<any>,
  onCloseModal: () => any,
};

type State = {
  selectedDay: WeekdayLabels
}

class CopyTimeLogModal extends Component<Props, State> {
  state: State = {
    selectedDay: 'mon',
  };

  handleSelectDay = (day: WeekdayLabels) => {
    this.setState({ selectedDay: day });
  };

  handleClose = () => {
    this.handleSelectDay('mon');
    this.props.onCloseModal();
  };

  handleSubmit = () => {
    const { log, onSubmit } = this.props;
    const { selectedDay } = this.state;

    onSubmit(log.project_id, {
      ...log,
      date: getNextWeekdayDate(new Date(log.date), selectedDay),
    }).then(this.handleClose);
  };

  handleCopyToDay = () => {
    const { log, onSubmit } = this.props;
    onSubmit(log.project_id, log).then(this.handleClose);
  };

  getDayText = (date: string) => `Copy to ${date && format(new Date(date), 'EEEE')}`;

  render(): React.ReactNode {
    const { log } = this.props;
    const { selectedDay } = this.state;
    const weekdays = {
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: 'Friday',
      sat: 'Saturday',
      sun: 'Sunday',
    };

    return (
      <>
        <ModalHeader
          title={`Copy to next ${weekdays[selectedDay]}?`}
          onCloseClick={this.handleClose}
        />
        <div className="copy-time-log-modal-buttons btn-group p-3 mx-auto" role="group">
          {map(weekdays, (day, key) => (
            <button
              key={key}
              type="button"
              className={classNames('btn', {
                'btn-primary primary-color': key === selectedDay,
                'btn-secondary': key !== selectedDay,
              })}
              onClick={() => this.handleSelectDay(key)}
            >
              {startCase(key)}
            </button>
          ))}
        </div>
        <ModalFooter>
          <ModalControls
            showEditButton
            disableButtons={false}
            isFormValid={false}
            onSubmitButtonClick={this.handleSubmit}
            onDeleteButtonClick={this.handleCopyToDay}
            onCloseButtonClick={this.handleClose}
            submitButtonText="Yes"
            deleteButtonText={this.getDayText(log.date)}
          />
        </ModalFooter>
      </>
    );
  }
}

export default CopyTimeLogModal as React.ComponentType<Props>;
